import { AppBar, Grid, Toolbar, useTheme } from "@mui/material";
import {
	BackdropCircularProgress,
	EmptyList,
	EnhancedSnackbar,
} from "@websential/cosmic-v20";
import {
	EHT_ONTARIO_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { GET_QUERY_KEY, QUERY_OPTIONS } from "../../../../common/constants";
import { IResponse, IServerError } from "../../../../models/common";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
	sortDDLByLabel,
	useNavigateToLogout,
	useRemoveQueriesOnUnmount,
} from "../../../../common/Common";

import { AuthService } from "../../../../services";
import { EHTOntarioReportDataGridWithColumnToggled } from "./EHTOntarioReportDataGridWithColumnToggled";
import { EHTOntarioReportHeader } from "../../EHTOntario/EHTOntarioReport/EHTOntarioReportHeader";
import FileSaver from "file-saver";
import { IAppState } from "../../../../store/reducers";
import { IDropDownListResponse } from "../../../../models/common/IDropDownListResponse";
import { IGetListRequest } from "../../../../models";
import { LookupFieldService } from "../../../../services/LookupFieldService";
import { OntarioEhtService } from "../../../../services/OntarioEhtService";
import { ReportsService } from "../../../../services/ReportsService";
import { setSelectedDrawerOptionsMenu } from "../../../../store/actions/drawerMenuOptionsActions";
import { useNavigate } from "react-router-dom";

export interface IEHTOntarioReportPage { }
const EHT_ONTARIO_REPORT_QUERY_KEY = "ehtOntario-report";

const useOntarioEhtSavedFrequency = (
	clientId: string,
	taxYear: number,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [
			'rq-remittance-saved-frequency',
		],
		queryFn: (data) => {

			return OntarioEhtService.getOntarioEhtSavedFrequency(
				clientId,
				taxYear,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});

const useGetRemittanceFrequencyDDL = () =>
	useQuery({
		queryKey: ["remittance-Frequency-ddl"],
		queryFn: (data) => {
			return OntarioEhtService.getRemittanceFrequencyDDL();
		},
		refetchOnWindowFocus: false,
	});
const useEHTOntariosReport = (
	clientId: string,
	
	remittanceFrequencyId: null | { label: string, value: string },
	taxYear:number,
	params: IGetListRequest, // must be serializable/stable,
	navigateToLogout: (path: any) => void
) =>
	useQuery({
		queryKey: [
			EHT_ONTARIO_REPORT_QUERY_KEY,
			clientId,
			
			remittanceFrequencyId,
			taxYear,
			params, // make sure params is stable (memoized or primitive values)
		],
		queryFn: () =>
			ReportsService.getEHTOntarioReport(
				clientId,
			
				remittanceFrequencyId,
				taxYear,
				params,
				navigateToLogout
			),
		refetchOnWindowFocus: false,
	});
export const useGetLookupFieldData = (lookupFieldId: string) =>
	useQuery({
		queryKey: [GET_QUERY_KEY.LOOKUP_FIELD_DATA_BY_ID, lookupFieldId],
		queryFn: (data) => {
			return LookupFieldService.getByIdd(lookupFieldId);
		},
		refetchOnWindowFocus: false,
	});

const useGetMaskStatus = () =>
	useQuery({
		queryKey: ["mask-status"],
		queryFn: (data) => {
			return AuthService.getMaskStatus();
		},
		refetchOnWindowFocus: false,
	});
export const EHTOntarioReport: React.FC<IEHTOntarioReportPage> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const clientIdStore = useSelector((state: IAppState) => state.client.id);
	const clientName = useSelector((state: IAppState) => state.client.clientName);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [isLoading, setIsLoading] = useState(false);
	const [ehtOntarioSetupReportData, setEHTOntarioReportData] =
		useState<any>(undefined);

	const {
		isLoading: isLoadingPayFrequency,
		data: ehtOntarioReportPayFrequencyList,
	} = useGetLookupFieldData("payPeriods");

	const { isPending: isPendingMaskStatus, data: maskStatus } =
		useGetMaskStatus();

	const formMethods = useForm<any>({
		// resolver: yupResolver(ValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const onImportFileClicked = useCallback(() => {
		alert(`Import Icon Clicked!`);
	}, []);

	const onExcelToPdfClicked = useCallback(() => {
		alert(`Excel Icon Clicked!`);
	}, []);

	const onApplyButtonClickedHandler = useCallback(() => {
		const values = formMethods.getValues();

	}, []);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	let [companySavedRemittance, setCompanySavedRemittance] = useState<any>(null)
	const { isPending: isPendingRQRamittanceSavedFrequency, data: rqRamittanceSavedFrequency }: any = useOntarioEhtSavedFrequency(
		clientIdStore,
		taxYear,
		navigateToLogout
	);

	const {
		isPending: isPendingRemittanceFrequencyDDL,
		data: remittanceFrequencyDDL,
	} = useGetRemittanceFrequencyDDL();

	useEffect(() => {
		if (remittanceFrequencyDDL && rqRamittanceSavedFrequency && rqRamittanceSavedFrequency.frequencies !== null) {
			let currentCompanySavedRemittance = remittanceFrequencyDDL.find((item: any) => item.value === rqRamittanceSavedFrequency.frequencies);
			setCompanySavedRemittance(currentCompanySavedRemittance)
		}
	}, [rqRamittanceSavedFrequency, remittanceFrequencyDDL])

	const { isPending, data } = useEHTOntariosReport(
		clientIdStore,
	
		companySavedRemittance,
		taxYear,
		queryParams,
		navigateToLogout
	);
	const ehtOntarioList: any | null = data;

	useEffect(() => {
		if (ehtOntarioList) {
			setEHTOntarioReportData(ehtOntarioList);
		}
	}, [ehtOntarioList]);

	
	const [zeroEHTOntario, setzeroEHTOntario] = useState(true);

	const [submitAddRemoveColumnsHandler, setSubmitAddRemoveColumnsHandler] =
		useState(undefined);
	const [onColumnReorder, setOnColumnReorder] = useState(undefined);

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const {
		isPending: isSubmittingAddRemoveHeaderColumns,
		mutate: submitAddRemoveHeaderColumns,
	} = useMutation({
		mutationFn: ReportsService.getEHTOntarioAddRemoveHeaderColumns,
		onSuccess: (res: any | IServerError | IResponse) => {
			if (res.status === 200) {
				return queryClient.invalidateQueries({
					queryKey: [EHT_ONTARIO_REPORT_QUERY_KEY],
				});
			} else {
				setSnackbarData({
					open: true,
					message: res.message
						? res.message
						: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err: any) => {
			setSnackbarData({
				open: true,
				message: err.message,
				severity: "error",
			});
		},
	});

	useEffect(() => {


		if (submitAddRemoveColumnsHandler) {
			submitAddRemoveHeaderColumns({
				clientId:clientIdStore,
				columns: submitAddRemoveColumnsHandler,
				navigateToLogout: navigateToLogout,
			});
		}
	}, [submitAddRemoveColumnsHandler]);


	const { isPending: isSubmittingColumnReorder, mutate: submitColumnReorder } =
		useMutation({
			mutationFn: OntarioEhtService.submitColumnReorder,
			onSuccess: (res: any | IServerError | IResponse) => {

				if (res.status === 201) {
					return queryClient.invalidateQueries({
						queryKey: [EHT_ONTARIO_REPORT_QUERY_KEY],
					});
				} else {
					setSnackbarData({
						open: true,
						message: res.message
							? res.message
							: "Something went wrong, try again later!",
						severity: "error",
					});
				}
			},
			onError: (err: any) => {
				setSnackbarData({
					open: true,
					message: err.message,
					severity: "error",
				});
			},
		});

	useEffect(() => {
		if (onColumnReorder) {
			submitColumnReorder({
				headerColumns: onColumnReorder,
				navigateToLogout: navigateToLogout,
			});
		}
	}, [onColumnReorder]);

	const ehtOntarioReportDDlItems = useMemo(() => {
		if (ehtOntarioReportPayFrequencyList) {
			if (
				ehtOntarioReportPayFrequencyList &&
				Array.isArray(ehtOntarioReportPayFrequencyList)
			) {
				let resources: IDropDownListResponse[] =
					sortDDLByLabel(ehtOntarioReportPayFrequencyList).map(
						(resourceItem: IDropDownListResponse) => ({
							// id: resourceItem.id,
							label: resourceItem.label,
							value: resourceItem.value,
						})
					);

				resources.unshift({
					label: "All",
					value: "all",
				});

				return resources;
			}
			return [];
		}
	}, [ehtOntarioReportPayFrequencyList]);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	useRemoveQueriesOnUnmount(["ehtOntario-report"]);

	const upadtedEHTOntarioListItems = useMemo(() => {
		return (
			ehtOntarioSetupReportData &&
			ehtOntarioSetupReportData.items &&
			ehtOntarioSetupReportData?.items.map((item: any) => ({
				...item,
			}))
		);
	}, [ehtOntarioSetupReportData]);

	// getting latest updated values of form fields using watch method


	const savePdfAsFile = (xmlData: any, filename: any) => {
		const blob = new Blob([xmlData], { type: "pdf;charset=utf-8" });
		FileSaver.saveAs(blob, filename);
	};

	const onExportButtonClick = async (selectedOption: string) => {

		try {
			setIsLoading(true);
			const response = await ReportsService.exportEHTOntarioReport(
				selectedOption,
				clientIdStore,
				companySavedRemittance,
				taxYear,
				queryParams
			);

			if (response) {
				if (selectedOption === "PDF") {
					if (response.status === 400) {
						setSnackbarData({
							open: true,
							message: response.data.message
								? response.data.message
								: "Something went wrong.",

							severity: "error",
						});
					} else {
						const filename = `${clientName} - EHT-Ontario-Report.pdf`;
						savePdfAsFile(response, filename);
					}
				} else if (selectedOption === "XLS") {
					if (response.status === 400) {
						setSnackbarData({
							open: true,
							message: response.data.message
								? response.data.message
								: "Something went wrong.",

							severity: "error",
						});
					} else {
						const filename = `${clientName} - EHT-Ontario-Report.xlsx`;
						savePdfAsFile(response, filename);
					}
				} else {
					const fileType =
						selectedOption === "XLS"
							? "application/vnd.ms-excel"
							: "text/csv;charset=utf-8;";
					const fileExtension = selectedOption === "XLS" ? "xls" : "csv";

					const blob = new Blob([response], { type: fileType });
					FileSaver.saveAs(blob, `${clientName} - EHT-Ontario-Report.${fileExtension}`);
				}
			} else {
				console.error("Error: No data received from the server");
			}
		} catch (err) {

			setIsLoading(false);
		} finally {
			setIsLoading(false);
		}

	};

	const expandedLabels = ["Reports", "Remittance"];
	const expandedEHTOntarioListOrSetupItem = "EHT Ontario"; // Special case for "List" under "EHTOntario"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Remittance" &&
				item.label === expandedEHTOntarioListOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedEHTOntarioListOrSetupItem && "/reports/eht-ontario",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EHT_ONTARIO_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);

	return (
		<>
			<div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
				}}
			>
				{"EHT Ontario Report"}
			</div>

			{/* <FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<EHTOntarioReportHeader
						ehtOntarioReportDDlItems={ehtOntarioReportDDlItems}
					/>
				</form>
			</FormProvider> */}

			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<BackdropCircularProgress
					open={
						isPending ||
						isSubmittingAddRemoveHeaderColumns ||
						isSubmittingColumnReorder ||
						isLoading || isPendingRemittanceFrequencyDDL || isPendingRQRamittanceSavedFrequency
					}
					testId="ehtOntario-report"
				/>

				<EHTOntarioReportDataGridWithColumnToggled
					columns={
						ehtOntarioSetupReportData && ehtOntarioSetupReportData.headerColumns
							? ehtOntarioSetupReportData.headerColumns.filter(
								(item: any) => item.field !== "id"
							)
							: []
					}
					completeHeaderColumnsList={
						ehtOntarioSetupReportData && ehtOntarioSetupReportData.totalHeaderColumns &&
							Object.keys(ehtOntarioSetupReportData.totalHeaderColumns).length !== 0
							? ehtOntarioSetupReportData.totalHeaderColumns
							: {}
					}
					submitAddRemoveColumnsHandler={(value: any) =>
						setSubmitAddRemoveColumnsHandler(value)
					}
					onColumnReorder={(value: any) => setOnColumnReorder(value)}
					rows={
						ehtOntarioSetupReportData && upadtedEHTOntarioListItems
							? upadtedEHTOntarioListItems
							: []
						// itams
					}
					showIndexColumn={true}
					showChecboxColumn={false}
					showSettingColumn={false}
					onImportButtonClickedHandler={onImportFileClicked}
					onImportExcelButtonClickedHandler={onExcelToPdfClicked}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						ehtOntarioSetupReportData && ehtOntarioSetupReportData.total
							? ehtOntarioSetupReportData.total
							: 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					searchFieldPlaceholder={"Search..."}
					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroEHTOntario(value)
					}
					pageTitle={"EHT Ontario Report"}
					onExportButtonClick={onExportButtonClick}
				/>

				{ehtOntarioSetupReportData ? (
					<AppBar
						position="sticky"
						color="default"
						elevation={1}
						sx={{
							backgroundColor: "#F7F7F7",

							boxShadow: "none",
							alignItems: "center",
							zIndex: 0,
							position: "sticky",
							bottom: 0,
						}}
					></AppBar>
				) : (
					<></>
				)}
			</Grid>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
